var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 573,
    height: 537,
    viewBox: "0 0 573 537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3726 253.878L351.357 78.4115L46.3726 253.878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3726 253.878L351.357 78.4115",
    stroke: "#F6FECC",
    strokeWidth: 92,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.637 367.415L424.621 191.948L119.637 367.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.637 367.415L424.621 191.948",
    stroke: "#F6FECC",
    strokeWidth: 92,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.997 148.942L526.85 135.18L502.997 148.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.997 148.942L526.85 135.18",
    stroke: "#F6FECC",
    strokeWidth: 92,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.978 463.749L458.697 327.849L226.978 463.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.978 463.749L458.697 327.849",
    stroke: "#F6FECC",
    strokeWidth: 92,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M516.592 337.059C520.344 337.396 523.121 340.735 522.788 344.512C522.455 348.289 519.139 351.083 515.386 350.747C511.634 350.41 508.858 347.071 509.19 343.294C509.523 339.517 512.84 336.723 516.592 337.059Z",
    stroke: "#F6FECC",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.839 480.222C129.936 480.768 134.448 486.195 133.908 492.333C133.367 498.47 127.977 503.01 121.88 502.463C115.782 501.917 111.27 496.49 111.811 490.352C112.352 484.215 117.741 479.675 123.839 480.222Z",
    stroke: "#F6FECC",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.071 24.3534C278.169 24.8998 282.681 30.3268 282.14 36.4644C281.599 42.602 276.21 47.1416 270.112 46.5952C264.015 46.0487 259.503 40.6218 260.044 34.4842C260.584 28.3466 265.974 23.8069 272.071 24.3534Z",
    stroke: "#F6FECC",
    strokeWidth: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1115 167.865C21.9325 167.865 24.2229 170.177 24.2229 173.026C24.2229 175.874 21.9325 178.186 19.1115 178.186C16.2904 178.186 14 175.874 14 173.026C14 170.177 16.2904 167.865 19.1115 167.865Z",
    stroke: "#F6FECC",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M414.398 498.154C417.219 498.154 419.51 500.467 419.51 503.315C419.51 506.163 417.219 508.476 414.398 508.476C411.577 508.476 409.287 506.163 409.287 503.315C409.287 500.467 411.577 498.154 414.398 498.154Z",
    stroke: "#F6FECC",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M475.736 21.6429L475.023 1.01257",
    stroke: "#F6FECC",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M465.513 11.3214L485.946 10.601",
    stroke: "#F6FECC",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.965 353.653L41.1829 333.087",
    stroke: "#F6FECC",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7421 345.051L53.1104 343.252",
    stroke: "#F6FECC",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M468.92 441.386L465.37 421.056",
    stroke: "#F6FECC",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M456.994 432.784L477.129 429.2",
    stroke: "#F6FECC",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M279.796 107.656C360.665 107.656 426.325 173.178 426.325 253.878C426.325 334.578 360.665 400.1 279.796 400.1C198.927 400.1 133.268 334.578 133.268 253.878C133.268 173.178 198.927 107.656 279.796 107.656Z",
    fill: "#F6FECC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M279.796 121.418C353.143 121.418 412.694 180.773 412.694 253.878C412.694 326.982 353.143 386.338 279.796 386.338C206.45 386.338 146.898 326.982 146.898 253.878C146.898 180.773 206.45 121.418 279.796 121.418Z",
    fill: "#AED100"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220.162 259.974L255.862 295.164L339.43 210.871",
    stroke: "white",
    strokeWidth: 18
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.414b7b0643fc68d14332596dc46872d8.svg";
export { ForwardRef as ReactComponent };